export interface IntegrationAuthenticationStatusNotConnected {
    type: 'NOT_CONNECTED';
}

export function createIntegrationAuthenticationStatusNotConnected(): IntegrationAuthenticationStatusNotConnected {
    return {
        type: 'NOT_CONNECTED',
    };
}
